module.exports = __webpack_public_path__ + "img/oceanShippingListImg_3.4758a66b.jpg";